import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "app/components/overlays/CustomNoRowsOverlay";
import LinearProgress from '@mui/material/LinearProgress';
import MDBox from "components/MDBox";
import { isEmpty } from "utils/validationUtil";
import { getDateInDDMMYYYYFormat } from "utils/dateUtil";
import "./AddActivityForm.css";
import { DEFAULT_TABLE_PAGE_SIZE } from "AppConstants";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Accepts activitiesData property from parent
export const ActivityDataGridBase = (props) => {
    // An activity carries only the project id, so the code shown here is resolved from the
    // client's project list the parent loads (the same pairing the Consolidated Report shows).
    const projectCodeById = useMemo(() => {
        const projects = Array.isArray(props?.projects) ? props.projects : [];
        return projects.reduce((acc, project) => {
            if (project?.id != null) acc[String(project.id)] = project.code ?? "";
            return acc;
        }, {});
    }, [props?.projects]);

    const columns = useMemo(() => [
        { field: 'projectCode', headerName: 'Project Code', width: 130, valueGetter: (value, row) => projectCodeById[String(row.projectId)] ?? "" },
        { field: 'clientTicketRef', headerName: 'Task Ticket / Details', width: 180 },
        { field: 'hoursSpent', headerName: 'Hours', width: 90, align: 'center', headerAlign: 'center' },
        { field: 'startDate', headerName: 'Date', width: 110, valueGetter: (value, row) => getDateInDDMMYYYYFormat(row.startDate) },
        {
            field: 'approvalStatus',
            headerName: 'Approval Status',
            width: 140,
            valueGetter: (value, row) => row.approvalStatus || "SUBMITTED",
            cellClassName: (params) => {
                const status = params.row.approvalStatus || "SUBMITTED";
                return `approval-status--${status.toLowerCase()}`;
            },
        },
        { field: 'description', headerName: 'Description/Reason', width: 400 },
    ], [projectCodeById]);

    const getData = () => {
        if(isEmpty(props?.activitiesData) || props?.activitiesData?.length === 0)
            return [];
        else
            return props?.activitiesData;
    }

    return (
        <MDBox pt={3}
            py={3}
            px={2}
            height={500}
        >
            <DataGrid
                density="compact"
                rows={ getData() }
                columns={columns}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                initialState={{ pagination: { paginationModel: { pageSize: DEFAULT_TABLE_PAGE_SIZE } } }}
                slots={{
                    loadingOverlay: LinearProgress,
                    noRowsOverlay: CustomNoRowsOverlay,
                }}
                // loading
                //getRowId={(activity)=> activity.id}
            />
        </MDBox>  
    );
}

ActivityDataGridBase.propTypes = {
    activitiesData: PropTypes.array.isRequired,
    // [{ id, code }] for the client the activities belong to; resolves the Project Code column.
    projects: PropTypes.array,
}
